module.exports = __webpack_public_path__ + "img/banner_6.98c718fc.jpg";